export const moduleNamespace = 'appAmRehabDecisionDashboard';
export const routeNamespace = '/rehab';
